import { type FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { type HTML } from '@editor2/types/pageElements';
import { updateElement } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import { CollapseState } from '@editor2/types/collapseState';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import RichTextEditor from './RichTextEditor';

interface Props {
	index: number;
	element: HTML;
	courseId: number;
}

const HtmlElement: FC<Props> = (props) => {
	const { index, element, courseId } = props;

	const debouncedDispatch = useDebouncedDispatch();

	const { collapseState } = useSelector((state: RootState) => state.courses[courseId]);
	const [codeMode, setCodeMode] = useState(false);

	useEffect(() => {
		if (collapseState.elements === CollapseState.RevealAllHTML) {
			setCodeMode(true);
		}

		if (collapseState.elements === CollapseState.CollapseAll) {
			setCodeMode(false);
		}

		if (collapseState.elements === CollapseState.ExpandAll) {
			setCodeMode(false);
		}
	}, [collapseState]);

	const handleChange = (value) => {
		debouncedDispatch(updateElement({ elementId: element.family_id, body: value, courseId }));
	};

	return (
		<RichTextEditor
			toolbar_id={element.family_id}
			text={element.body}
			onChange={handleChange}
			forceCodeMode={codeMode}
		/>
	);
};

export default HtmlElement;
